// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__zLAae {
    height: rem(84px);
    margin-bottom: rem(120px);
    background-color: var(--mantine-color-body);
    border-bottom: rem(1px) solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));
  }
  
  .Header_inner__P-ycz {
    height: rem(84px);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .Header_links__CTZqY {
    padding-top: var(--mantine-spacing-lg);
    height: rem(84px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .Header_mainLinks__LXQUM {
    margin-right: calc(var(--mantine-spacing-sm) * -1);
  }
  
  .Header_mainLink__NGi2B {
    text-transform: uppercase;
    font-size: var(--mantine-font-size-xs);
    color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-1));
    padding: rem(7px) var(--mantine-spacing-sm);
    font-weight: 700;
    border-bottom: rem(2px) solid transparent;
    transition:
      border-color 100ms ease,
      color 100ms ease;
  
    @mixin hover {
      color: light-dark(var(--mantine-color-black), var(--mantine-color-white));
      text-decoration: none;
    }
  
    &[data-active] {
      color: light-dark(var(--mantine-color-black), var(--mantine-color-white));
      border-bottom-color: var(--mantine-color-blue-6);
    }
  }
  
  .Header_secondaryLink__q6Ea3 {
    color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-1));
    font-size: var(--mantine-font-size-xs);
    text-transform: uppercase;
    transition: color 100ms ease;
  
    @mixin hover {
      color: light-dark(var(--mantine-color-black), var(--mantine-color-white));
      text-decoration: none;
    }
  }

  .Header_logo__qYcbX {
    width: 100%;
    max-width: 30px;
    height: auto;
  }
  
  @media (max-width: 768px) {
    .Header_logo__qYcbX {
      max-width: 30px;
    }
  }
  
  @media (max-width: 480px) {
    .Header_logo__qYcbX {
      max-width: 25px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/faq/Header.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,2CAA2C;IAC3C,kGAAkG;EACpG;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,sCAAsC;IACtC,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,kDAAkD;EACpD;;EAEA;IACE,yBAAyB;IACzB,sCAAsC;IACtC,2EAA2E;IAC3E,2CAA2C;IAC3C,gBAAgB;IAChB,yCAAyC;IACzC;;sBAEkB;;IAElB;MACE,yEAAyE;MACzE,qBAAqB;IACvB;;IAEA;MACE,yEAAyE;MACzE,gDAAgD;IAClD;EACF;;EAEA;IACE,2EAA2E;IAC3E,sCAAsC;IACtC,yBAAyB;IACzB,4BAA4B;;IAE5B;MACE,yEAAyE;MACzE,qBAAqB;IACvB;EACF;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;EACF","sourcesContent":[".header {\n    height: rem(84px);\n    margin-bottom: rem(120px);\n    background-color: var(--mantine-color-body);\n    border-bottom: rem(1px) solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));\n  }\n  \n  .inner {\n    height: rem(84px);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  \n  .links {\n    padding-top: var(--mantine-spacing-lg);\n    height: rem(84px);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  .mainLinks {\n    margin-right: calc(var(--mantine-spacing-sm) * -1);\n  }\n  \n  .mainLink {\n    text-transform: uppercase;\n    font-size: var(--mantine-font-size-xs);\n    color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-1));\n    padding: rem(7px) var(--mantine-spacing-sm);\n    font-weight: 700;\n    border-bottom: rem(2px) solid transparent;\n    transition:\n      border-color 100ms ease,\n      color 100ms ease;\n  \n    @mixin hover {\n      color: light-dark(var(--mantine-color-black), var(--mantine-color-white));\n      text-decoration: none;\n    }\n  \n    &[data-active] {\n      color: light-dark(var(--mantine-color-black), var(--mantine-color-white));\n      border-bottom-color: var(--mantine-color-blue-6);\n    }\n  }\n  \n  .secondaryLink {\n    color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-1));\n    font-size: var(--mantine-font-size-xs);\n    text-transform: uppercase;\n    transition: color 100ms ease;\n  \n    @mixin hover {\n      color: light-dark(var(--mantine-color-black), var(--mantine-color-white));\n      text-decoration: none;\n    }\n  }\n\n  .logo {\n    width: 100%;\n    max-width: 30px;\n    height: auto;\n  }\n  \n  @media (max-width: 768px) {\n    .logo {\n      max-width: 30px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .logo {\n      max-width: 25px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__zLAae`,
	"inner": `Header_inner__P-ycz`,
	"links": `Header_links__CTZqY`,
	"mainLinks": `Header_mainLinks__LXQUM`,
	"mainLink": `Header_mainLink__NGi2B`,
	"secondaryLink": `Header_secondaryLink__q6Ea3`,
	"logo": `Header_logo__qYcbX`
};
export default ___CSS_LOADER_EXPORT___;
